<template>
  <v-container
    grid-list-lg
  >
    <v-layout
      v-if="componentLoading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
      justify-center
    >
      <v-flex class="max-maxWidth">
        <v-card
          id="notificationContent"
          class="max-shadow"
        >
          <v-card-text>
            <v-container
              grid-list-lg
              fluid
              class="pa-2"
            >
              <v-layout column>
                <v-layout
                  row
                  wrap
                  justify-space-between
                >
                  <v-icon
                    color="iconColor"
                    class="pa-4"
                  >
                    notifications
                  </v-icon>
                  <v-flex>
                    <toggle
                      v-model="notificationSettings.host_notifications"
                      :disabled="disabled"
                      title="Notifications"
                      caption="Turn on/off system wide notifications"
                    />
                  </v-flex>
                </v-layout>
                <template v-if="notificationSettings.host_notifications">
                  <v-layout
                    row
                    wrap
                    justify-space-between
                  >
                    <v-icon
                      color="iconColor"
                      class="pa-4"
                    >
                      system_update
                    </v-icon>
                    <v-flex>
                      <toggle
                        v-model="notificationSettings.push_notifications"
                        :disabled="disabled"
                        title="System Push Notifications"
                        caption="Turn on/off system push notifications"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-space-between
                  >
                    <v-icon
                      color="iconColor"
                      class="pa-4"
                    >
                      mail
                    </v-icon>
                    <v-flex>
                      <toggle
                        v-model="notificationSettings.email_notifications"
                        :disabled="disabled"
                        title="E-mail Notifications"
                        caption="Turn on/off e-mail notifications"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-space-between
                  >
                    <v-icon
                      color="iconColor"
                      class="pa-4"
                    >
                      sms
                    </v-icon>
                    <v-flex>
                      <toggle
                        v-model="notificationSettings.sms_notifications"
                        :disabled="disabled"
                        title="SMS Notifications"
                        caption="Turn on/off sms notifications"
                      />
                    </v-flex>
                  </v-layout>
                </template>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import toggle from '@/components/common/Toggle';
import _get from 'lodash/get';
import { database } from '@/firebase';

export default {
  name: 'NotificationChannels',
  components: {
    toggle
  },
  data() {
    return {
      disabled: false,
      notificationSettings: {},

      componentLoading: true
    };
  },
  computed: {
    notificationRef() {
      const lid = _get(this.$store.state.VMS, 'lid');
      if (!lid) return null;
      return database.ref(`vms/${lid}/settings/notifications`);
    }
  },
  watch: {
    notificationRef: {
      handler(val) {
        if (!val) return;
        this.fetchSettings();
      },
      immediate: true
    },
    notificationSettings: {
      handler(val) {
        this.notificationRef.update(val);
      },
      deep: true
    }
  },
  created() {
    this.$store.commit('setToolbarTitle', {
      toolbarTitle: 'Notification Settings'
    });
  },
  methods: {
    fetchSettings() {
      this.notificationRef.once('value').then(notificationSnapshot => {
        this.componentLoading = false;
        const notifications = notificationSnapshot.val();
        if (!notifications) return;
        this.notificationSettings = notifications;
      });
    }
  }
};
</script>
<style>
/* #notificationContent {
  height: calc(100vh - var(--toolbar-height));
  overflow-y: scroll;
} */
</style>

